import {
  faTwitter as freeFabFaTwitter,
  faFacebook as freeFabFaFacebook,
  faInstagram as freeFabFaInstagram,
  faLinkedin as freeFabFaLinkedin,
  faYoutube as freeFabFaYoutube,
  faPinterestP as freeFabFaPinterestP,
  faFacebookF as freeFabFaFacebookF,
  faLinkedinIn as freeFabFaLinkedinIn
} from '@fortawesome/free-brands-svg-icons'

import {
  faChevronDown as proFalFaChevronDown,
  faChevronRight as proFalFaChevronRight,
  faChevronUp as proFalFaChevronUp,
  faChevronLeft as proFalFaChevronLeft,
  faAngleRight as proFalFaAngleRight,
  faAngleDown as proFalFaAngleDown,
  faAngleUp as proFalFaAngleUp,
  faAngleLeft as proFalFaAngleLeft,
  faArrowRight as proFalFaArrowRight,
  faArrowLeft as proFalFaArrowLeft,
  faArrowUp as proFalFaArrowUp,
  faArrowDown as proFalFaArrowDown,
  faBars as proFalFaBars,
  faXmark as proFalFaXmark,
  faSortDown as proFalFaSortDown,
  faStarSharp as proFalFaStarSharp,
  faClock as proFalFaClock,
  faCalendar as proFalFaCalendar,
  faCirclePlus as proFalFaCirclePlus,
  faCircleMinus as proFalFaCircleMinus,
  faSquareCheck as proFalFaSquareCheck,
  faLocationDot as proFalFaLocationDot,
  faBed as proFalFaBed,
  faBus as proFalFaBus,
  faCar as proFalFaCar,
  faShip as proFalFaShip,
  faCity as proFalFaCity,
  faPlane as proFalFaPlane,
  faPlaneUp as proFalFaPlaneUp,
  faLandmark as proFalFaLandmark,
  faCheck as proFalFaCheck,
  faCircleInfo as proFalFaCircleInfo,
  faArrowsRotate as proFalFaArrowsRotate
} from '@fortawesome/pro-light-svg-icons'

import {
  faChevronDown as proFasFaChevronDown,
  faChevronRight as proFasFaChevronRight,
  faChevronUp as proFasFaChevronUp,
  faChevronLeft as proFasFaChevronLeft,
  faAngleRight as proFasFaAngleRight,
  faAngleDown as proFasFaAngleDown,
  faAngleUp as proFasFaAngleUp,
  faAngleLeft as proFasFaAngleLeft,
  faArrowRight as proFasFaArrowRight,
  faArrowLeft as proFasFaArrowLeft,
  faArrowUp as proFasFaArrowUp,
  faArrowDown as proFasFaArrowDown,
  faBars as proFasFaBars,
  faXmark as proFasFaXmark,
  faSortDown as proFasFaSortDown,
  faStarSharp as proFasFaStarSharp,
  faClock as proFasFaClock,
  faCalendar as proFasFaCalendar,
  faCirclePlus as proFasFaCirclePlus,
  faCircleMinus as proFasFaCircleMinus,
  faSquareCheck as proFasFaSquareCheck,
  faLocationDot as proFasFaLocationDot,
  faBed as proFasFaBed,
  faBus as proFasFaBus,
  faCar as proFasFaCar,
  faShip as proFasFaShip,
  faCity as proFasFaCity,
  faPlane as proFasFaPlane,
  faPlaneUp as proFasFaPlaneUp,
  faLandmark as proFasFaLandmark,
  faPlaneDeparture as proFasFaPlaneDeparture,
  faCheck as proFasFaCheck,
  faCircleInfo as proFasFaCircleInfo,
  faArrowsRotate as proFasFaArrowsRotate
} from '@fortawesome/pro-solid-svg-icons'

import {
  faChevronDown as proFarFaChevronDown,
  faChevronRight as proFarFaChevronRight,
  faChevronUp as proFarFaChevronUp,
  faChevronLeft as proFarFaChevronLeft,
  faAngleRight as proFarFaAngleRight,
  faAngleDown as proFarFaAngleDown,
  faAngleUp as proFarFaAngleUp,
  faAngleLeft as proFarFaAngleLeft,
  faArrowRight as proFarFaArrowRight,
  faArrowLeft as proFarFaArrowLeft,
  faArrowUp as proFarFaArrowUp,
  faArrowDown as proFarFaArrowDown,
  faBars as proFarFaBars,
  faXmark as proFarFaXmark,
  faSortDown as proFarFaSortDown,
  faStarSharp as proFarFaStarSharp,
  faClock as proFarFaClock,
  faCalendar as proFarFaCalendar,
  faCirclePlus as proFarFaCirclePlus,
  faCircleMinus as proFarFaCircleMinus,
  faSquareCheck as proFarFaSquareCheck,
  faLocationDot as proFarFaLocationDot,
  faBed as proFarFaBed,
  faBus as proFarFaBus,
  faCar as proFarFaCar,
  faShip as proFarFaShip,
  faCity as proFarFaCity,
  faPlane as proFarFaPlane,
  faPlaneUp as proFarFaPlaneUp,
  faLandmark as proFarFaLandmark,
  faCheck as proFarFaCheck,
  faCircleInfo as proFarFaCircleInfo,
  faArrowsRotate as proFarFaArrowsRotate,
  faMap as proFarFaMap
} from '@fortawesome/pro-regular-svg-icons'

import {
  faStarSharpHalf as proFadFaStarSharpHalf
} from '@fortawesome/pro-duotone-svg-icons'

import {
  faStar as sharpFasFaStar,
  faCircleQuestion as sharpFasFaCircleQuestion,
  faHouseChimney as sharpFasFaHouseChimney,
  faChevronDown as sharpFasFaChevronDown,
  faChevronRight as sharpFasFaChevronRight,
  faChevronUp as sharpFasFaChevronUp,
  faChevronLeft as sharpFasFaChevronLeft
} from '@fortawesome/sharp-solid-svg-icons'

import {
  faCalendarDays as sharpFarFaCalendarDays,
  faArrowRight as sharpFarFaArrowRight,
  faArrowLeft as sharpFarFaArrowLeft,
  faArrowUp as sharpFarFaArrowUp,
  faArrowDown as sharpFarFaArrowDown
} from '@fortawesome/sharp-regular-svg-icons'

export default {freeFabFaTwitter, freeFabFaFacebook, freeFabFaInstagram, freeFabFaLinkedin, freeFabFaYoutube, freeFabFaPinterestP, freeFabFaFacebookF, freeFabFaLinkedinIn, proFalFaChevronDown, proFalFaChevronRight, proFalFaChevronUp, proFalFaChevronLeft, proFalFaAngleRight, proFalFaAngleDown, proFalFaAngleUp, proFalFaAngleLeft, proFalFaArrowRight, proFalFaArrowLeft, proFalFaArrowUp, proFalFaArrowDown, proFalFaBars, proFalFaXmark, proFalFaSortDown, proFalFaStarSharp, proFalFaClock, proFalFaCalendar, proFalFaCirclePlus, proFalFaCircleMinus, proFalFaSquareCheck, proFalFaLocationDot, proFalFaBed, proFalFaBus, proFalFaCar, proFalFaShip, proFalFaCity, proFalFaPlane, proFalFaPlaneUp, proFalFaLandmark, proFalFaCheck, proFalFaCircleInfo, proFalFaArrowsRotate, proFasFaChevronDown, proFasFaChevronRight, proFasFaChevronUp, proFasFaChevronLeft, proFasFaAngleRight, proFasFaAngleDown, proFasFaAngleUp, proFasFaAngleLeft, proFasFaArrowRight, proFasFaArrowLeft, proFasFaArrowUp, proFasFaArrowDown, proFasFaBars, proFasFaXmark, proFasFaSortDown, proFasFaStarSharp, proFasFaClock, proFasFaCalendar, proFasFaCirclePlus, proFasFaCircleMinus, proFasFaSquareCheck, proFasFaLocationDot, proFasFaBed, proFasFaBus, proFasFaCar, proFasFaShip, proFasFaCity, proFasFaPlane, proFasFaPlaneUp, proFasFaLandmark, proFasFaPlaneDeparture, proFasFaCheck, proFasFaCircleInfo, proFasFaArrowsRotate, proFarFaChevronDown, proFarFaChevronRight, proFarFaChevronUp, proFarFaChevronLeft, proFarFaAngleRight, proFarFaAngleDown, proFarFaAngleUp, proFarFaAngleLeft, proFarFaArrowRight, proFarFaArrowLeft, proFarFaArrowUp, proFarFaArrowDown, proFarFaBars, proFarFaXmark, proFarFaSortDown, proFarFaStarSharp, proFarFaClock, proFarFaCalendar, proFarFaCirclePlus, proFarFaCircleMinus, proFarFaSquareCheck, proFarFaLocationDot, proFarFaBed, proFarFaBus, proFarFaCar, proFarFaShip, proFarFaCity, proFarFaPlane, proFarFaPlaneUp, proFarFaLandmark, proFarFaCheck, proFarFaCircleInfo, proFarFaArrowsRotate, proFarFaMap, proFadFaStarSharpHalf, sharpFasFaStar, sharpFasFaCircleQuestion, sharpFasFaHouseChimney, sharpFasFaChevronDown, sharpFasFaChevronRight, sharpFasFaChevronUp, sharpFasFaChevronLeft, sharpFarFaCalendarDays, sharpFarFaArrowRight, sharpFarFaArrowLeft, sharpFarFaArrowUp, sharpFarFaArrowDown}